'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 33 28',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement('path', {
                d: 'M31.524 14.42a7.133 7.133 0 0 1-.37-.249c-.622-.445-1.096-.955-1.409-1.515-.214-.383-.341-.946-.489-1.598-.32-1.413-.717-3.17-2.23-4.543-1.495-1.5.183-2.74.107-3.585a1.009 1.009 0 0 0-.842-.906A2.132 2.132 0 0 0 25.952 2c-1.788 0-4.162 2.222-4.32 2.29h-.002c-.016-.002-1.667-.27-3.884-.27-2.44 0-5.941.324-8.761 1.872-1.633.896-2.872 2.1-3.683 3.582-.758 1.384-1.161 3.05-1.201 4.956a2.12 2.12 0 0 1-.473-.065c.436-.617.607-1.613-.293-1.877-.829-.244-1.523.424-1.313 1.249.071.278.213.51.399.698-.38.038-.626-.3-.794-.596-.214-.377-.794-.038-.58.34.276.488.671.88 1.251.93.28.025.557-.076.796-.232.32.134.67.206 1.005.222.046 3.828.879 5.467 3.7 7.455.027.018.054.036.082.052.195.11.457.492.602 1.68.022.18.041.373.055.574.037.498.431.895.929.933l1.208.094.079.002a1.009 1.009 0 0 0 1.005-1.084c-.006-.359.047-.612.158-.752.084-.107.193-.147.344-.124 1.263.311 2.786.469 4.527.469 2.288 0 4.329-.279 4.923-.386a.433.433 0 0 1 .077-.007c.406 0 .586.653.658 1.043l.018.104a1.009 1.009 0 0 0 1.09.843l1.419-.135a1.008 1.008 0 0 0 .897-1.18 25.5 25.5 0 0 1-.023-.133c-.052-.307-.21-1.241-.047-1.405a12.805 12.805 0 0 0 2.633-2.49l.023-.027c.874-.953 1.951-1.304 2.702-1.43.486-.081.842-.502.842-.995v-2.923c0-.35-.18-.673-.476-.857zm-28.183-.952c-.009.166-.124.4-.29.558a1.494 1.494 0 0 1-.08.07l-.001.002-.002-.002a1.443 1.443 0 0 1-.08-.07c-.166-.159-.281-.392-.29-.558-.01-.178.167-.322.371-.322s.382.144.372.322zm22.294-1.84a1.127 1.127 0 0 1 0-2.254 1.127 1.127 0 0 1 0 2.254z',
                fill: props.fill,
                fillRule: 'nonzero',
                stroke: 'none',
                strokeWidth: '1'
            })
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: '#FFF',
    width: '33px',
    height: '28px'
};

Icon.displayName = 'ProductMoneyBoxWhite';

exports.default = Icon;